import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OptionService } from '../option.service';
import { SystemData } from '../systemData.model';

@Component({
  selector: 'app-system-data',
  templateUrl: './system-data.component.html',
  styleUrls: ['./system-data.component.css']
})
export class SystemDataComponent implements OnInit {

  systemData:SystemData = {} as SystemData;
  spinnerOverlay = false
  constructor(private service:OptionService,private snackBar: MatSnackBar,private translateService:TranslateService) { }

  ngOnInit(): void {
    this.get()
  }

  get(){
    this.spinnerOverlay = true;
    this.service.getDefinitions().subscribe(data => {
      
      if(data != null){
      this.systemData = data
      }
      this.spinnerOverlay = false;
    },
    error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

put(){
  this.spinnerOverlay = true;
  this.service.updateDefinitions(this.systemData).subscribe(data => {
    this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
    this.spinnerOverlay = false;
  },error => {
    console.log(error);
    this.spinnerOverlay = false;
  })
}

  submit(){
this.put();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
